import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class EditMatchBasicPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "match", null);
    _defineProperty(this, "isEdit", false);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "saving", false);
    // Available lists
    _defineProperty(this, "seasons", []);
    _defineProperty(this, "teams", []);
    _defineProperty(this, "rivals", []);
    _defineProperty(this, "competitions", []);
    // Form fields state
    _defineProperty(this, "competitionId", '');
    _defineProperty(this, "seasonId", '');
    _defineProperty(this, "seasonName", '');
    _defineProperty(this, "opponent", '');
    _defineProperty(this, "rivalId", '');
    _defineProperty(this, "jornada", '');
    _defineProperty(this, "status", 'scheduled');
    _defineProperty(this, "isLocal", true);
    _defineProperty(this, "isKnockout", false);
    _defineProperty(this, "matchDate", '');
    _defineProperty(this, "teamId", '');
    _defineProperty(this, "pressConferenceUrl", '');
    _defineProperty(this, "callupUrl", '');
    _defineProperty(this, "tvChannel", '');
    _defineProperty(this, "previewUrl", '');
    _defineProperty(this, "postPressConferenceUrl", '');
    _defineProperty(this, "highlightsUrl", '');
    _defineProperty(this, "fullMatchUrl", '');
    _defineProperty(this, "referee", '');
    _defineProperty(this, "varReferee", '');
    _defineProperty(this, "attendance", '');
    _defineProperty(this, "notesHtml", '');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    const id = m.route.param('id');
    this.isEdit = !!id;
    this.loadAllData(id);
  }
  loadAllData(id) {
    this.loading = true;
    m.redraw();
    const promises = [app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
    }), app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/teams'
    }), app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/rivals'
    }), app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/competitions'
    })];
    if (this.isEdit && id) {
      promises.push(app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches/".concat(id, "?include=players,discussion,season,preMatchDiscussion,bolillaDiscussion,rival,competition")
      }));
    }
    Promise.all(promises).then(responses => {
      this.seasons = app.store.pushPayload(responses[0]);
      this.teams = app.store.pushPayload(responses[1]);
      this.rivals = app.store.pushPayload(responses[2]);
      this.competitions = responses[3] && responses[3].data ? responses[3].data.map(item => app.store.pushObject(item)) : [];
      if (this.isEdit && id && responses[4]) {
        this.match = app.store.pushPayload(responses[4]);
        if (this.match) {
          this.initForm();
        } else {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_not_found'));
          m.route.set(app.route('bizkaitarra-lineup.matches'));
        }
      } else {
        // Select default season if available
        if (this.seasons.length > 0) {
          const sortedSeasons = [...this.seasons].sort((a, b) => b.name().localeCompare(a.name()));
          this.seasonId = sortedSeasons[0].id();
          this.seasonName = sortedSeasons[0].name();
        }
        // Por defecto seleccionar Liga
        const defaultComp = this.competitions.find(c => c.slug && c.slug() === 'laliga') || this.competitions.find(c => c.nameEs && c.nameEs().toLowerCase().includes('liga') || c.name && c.name().toLowerCase().includes('liga'));
        if (defaultComp) {
          this.competitionId = String(defaultComp.id());
        }
      }
      this.loading = false;
      m.redraw();
    }).catch(error => {
      console.error('Error loading basic editor data:', error);
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_load'));
      m.route.set(app.route('bizkaitarra-lineup.matches'));
      this.loading = false;
      m.redraw();
    });
  }
  initForm() {
    if (!this.match) return;
    const comp = typeof this.match.competition === 'function' ? this.match.competition() : null;
    this.competitionId = this.match.competitionId() ? String(this.match.competitionId()) : comp ? String(comp.id()) : '';
    if (!this.competitionId && this.competitions.length > 0) {
      const defaultComp = this.competitions.find(c => c.slug && c.slug() === 'laliga');
      if (defaultComp) {
        this.competitionId = String(defaultComp.id());
      }
    }
    this.seasonId = this.match.seasonId() ? String(this.match.seasonId()) : '';
    this.seasonName = this.match.seasonName() || '';
    this.opponent = this.match.opponent() || '';
    this.rivalId = this.match.rival() ? String(this.match.rival().id()) : '';
    this.jornada = this.match.jornada() || '';
    this.status = this.match.attribute('status') || (typeof this.match.status === 'function' ? this.match.status() : null) || 'scheduled';
    this.isLocal = !!this.match.isLocal();
    this.isKnockout = !!this.match.isKnockout();
    this.matchDate = this.formatDateForInput(this.match.matchDate());
    this.teamId = this.match.teamId() ? String(this.match.teamId()) : '';
    this.pressConferenceUrl = this.match.pressConferenceUrl() || '';
    this.callupUrl = this.match.callupUrl() || '';
    this.tvChannel = this.match.tvChannel() || '';
    this.previewUrl = this.match.previewUrl() || '';
    this.postPressConferenceUrl = this.match.postPressConferenceUrl() || '';
    this.highlightsUrl = this.match.highlightsUrl() || '';
    this.fullMatchUrl = this.match.fullMatchUrl() || '';
    this.referee = this.match.referee() || '';
    this.varReferee = this.match.varReferee() || '';
    this.attendance = this.match.attendance() ? String(this.match.attendance()) : '';
    this.notesHtml = this.match.notesHtml() || '';
  }
  formatDateForInput(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const pad = n => n.toString().padStart(2, '0');
    return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), "T").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()));
  }
  saveMatch(e) {
    e.preventDefault();
    if (!this.seasonId) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.required_season'));
      return;
    }
    if (!this.opponent.trim()) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.required_opponent'));
      return;
    }
    if (!this.teamId) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.required_team'));
      return;
    }
    this.saving = true;
    const dateToISO = val => {
      if (!val) return null;
      const d = new Date(val);
      return isNaN(d.getTime()) ? null : d.toISOString();
    };
    const method = this.isEdit ? 'PATCH' : 'POST';
    const url = app.forum.attribute('apiUrl') + '/nagusi/match-ratings/matches' + (this.isEdit ? '/' + this.match.id() : '');
    const attributes = {
      seasonId: parseInt(this.seasonId),
      season: this.seasonName,
      competitionId: this.competitionId ? parseInt(this.competitionId) : null,
      opponent: this.opponent,
      teamId: parseInt(this.teamId),
      matchDate: dateToISO(this.matchDate),
      isLocal: this.isLocal,
      isKnockout: this.isKnockout,
      jornada: this.jornada,
      status: this.status,
      rivalId: this.rivalId ? parseInt(this.rivalId) : null,
      pressConferenceUrl: this.pressConferenceUrl.trim() || null,
      callupUrl: this.callupUrl.trim() || null,
      tvChannel: this.tvChannel.trim() || null,
      previewUrl: this.previewUrl.trim() || null,
      postPressConferenceUrl: this.postPressConferenceUrl.trim() || null,
      highlightsUrl: this.highlightsUrl.trim() || null,
      fullMatchUrl: this.fullMatchUrl.trim() || null,
      referee: this.referee.trim() || null,
      varReferee: this.varReferee.trim() || null,
      attendance: this.attendance.trim() !== '' ? parseInt(this.attendance) : null,
      notesHtml: this.notesHtml.trim() || null
    };
    app.request({
      method,
      url,
      body: {
        data: {
          type: 'nagusi_matches',
          attributes
        }
      }
    }).then(res => {
      if (res && res.meta && typeof res.meta.pendingCount !== 'undefined') {
        if (!app.forum.data.attributes) {
          app.forum.data.attributes = {};
        }
        app.forum.data.attributes.pendingTaldezainaTasksCount = res.meta.pendingCount;
      }
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, this.isEdit ? app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.success_update') : app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.success_create'));
      m.route.set(app.route('bizkaitarra-lineup.matches'));
    }).catch(error => {
      console.error('Error saving match:', error);
      this.saving = false;
      if (error && error.response && error.response.errors) {
        const firstErr = error.response.errors[0];
        if (firstErr && firstErr.detail) {
          app.alerts.show({
            type: 'error'
          }, firstErr.detail);
        } else {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_save'));
        }
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_validation'));
      }
      m.redraw();
    });
  }
  view() {
    if (!this.canManage) return null;
    if (this.loading) {
      return m("div", {
        className: "EditMatchBasicPage"
      }, m("div", {
        className: "container",
        style: "padding: 40px; text-align: center;"
      }, m(LoadingIndicator, null)));
    }
    return m("div", {
      className: "EditMatchBasicPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.matches'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.nav_back_matches')), m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-user-shield"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.nav_back_taldezaina'))), m("div", {
      className: "EditMatch-header",
      style: "margin-bottom: 40px;"
    }, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, this.isEdit ? app.translator.trans('bizkaitarra-lineup.forum.matches.edit_data_title') : app.translator.trans('bizkaitarra-lineup.forum.matches.create_data_title')), this.isEdit && m("p", {
      style: "color: var(--muted-color); font-size: 1.25em; margin-top: 4px;"
    }, this.match.getName())), m("form", {
      onsubmit: this.saveMatch.bind(this)
    }, m("div", {
      style: "max-width: 650px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 30px; display: flex; flex-direction: column; gap: 20px; box-shadow: 0 8px 32px rgba(0,0,0,0.15);"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 10px 0; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 12px; color: var(--heading-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.section_details')), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 15px;"
    }, m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_season'), " *"), m("select", {
      className: "FormControl",
      value: this.seasonId,
      onchange: e => {
        const sId = e.target.value;
        this.seasonId = sId;
        const found = this.seasons.find(s => String(s.id()) === String(sId));
        if (found) this.seasonName = found.name();
        m.redraw();
      },
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); height: 40px;"
    }, m("option", {
      value: ""
    }, "-- " + app.translator.trans('bizkaitarra-lineup.forum.matches.field_season') + " --"), this.seasons.map(s => m("option", {
      value: s.id()
    }, s.name())))), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, "Competici\xF3n"), m("select", {
      className: "FormControl",
      value: this.competitionId,
      onchange: e => {
        this.competitionId = e.target.value;
        const selectedComp = this.competitions.find(c => String(c.id()) === String(this.competitionId));
        if (selectedComp && typeof selectedComp.format === 'function' && selectedComp.format() === 'knockout' && !this.isEdit) {
          this.isKnockout = true;
        }
        m.redraw();
      },
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); height: 40px;"
    }, m("option", {
      value: ""
    }, "-- Sin competici\xF3n --"), this.competitions.map(c => m("option", {
      value: c.id()
    }, c.nameEs ? c.nameEs() : c.name ? c.name() : c.slug()))))), (() => {
      const selectedComp = this.competitions.find(c => String(c.id()) === String(this.competitionId));
      if (!selectedComp) return null;
      return m("div", {
        style: "display: flex; align-items: center; justify-content: space-between; gap: 10px; font-size: 0.85em; color: var(--muted-color); background: rgba(255,255,255,0.03); padding: 8px 14px; border-radius: 8px; border-left: 4px solid ".concat(selectedComp.color() || '#d50000', ";")
      }, m("div", {
        style: "display: flex; align-items: center; gap: 8px;"
      }, selectedComp.iconUrl() && m("img", {
        src: selectedComp.iconUrl(),
        alt: "",
        style: "width: 20px; height: 20px; object-fit: contain;"
      }), m("span", {
        style: "font-weight: 600; color: var(--heading-color);"
      }, selectedComp.nameEs ? selectedComp.nameEs() : selectedComp.name())), m("div", {
        style: "display: inline-flex; align-items: center; gap: 10px; font-size: 0.85em;"
      }, m("span", {
        style: "color: ".concat(selectedComp.countsForLineupStanding() ? '#4ade80' : '#f87171', "; font-weight: 500;")
      }, selectedComp.countsForLineupStanding() ? '✓ 11 Aldeanos' : '✗ Sin 11A'), m("span", {
        style: "color: rgba(255,255,255,0.2);"
      }, "|"), m("span", {
        style: "color: ".concat(selectedComp.countsForBolillaStanding() ? '#4ade80' : '#f87171', "; font-weight: 500;")
      }, selectedComp.countsForBolillaStanding() ? '✓ Bolilla' : '✗ Sin Bolilla')));
    })(), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 15px;"
    }, m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_jornada')), m("input", {
      className: "FormControl",
      placeholder: String(app.translator.trans('bizkaitarra-lineup.forum.matches.field_jornada_placeholder')),
      value: this.jornada,
      oninput: e => this.jornada = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_location')), m("select", {
      className: "FormControl",
      value: this.isLocal ? '1' : '0',
      onchange: e => {
        this.isLocal = e.target.value === '1';
        m.redraw();
      },
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); height: 40px;"
    }, m("option", {
      value: "1"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.location_local')), m("option", {
      value: "0"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.location_visitor'))))), m("div", {
      style: "display: flex; align-items: center; gap: 12px; background: rgba(255,255,255,0.02); padding: 12px 14px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.08);"
    }, m("input", {
      type: "checkbox",
      id: "chkKnockout",
      checked: this.isKnockout,
      onchange: e => {
        this.isKnockout = e.target.checked;
        m.redraw();
      },
      style: "width: 18px; height: 18px; cursor: pointer;"
    }), m("div", {
      style: "display: flex; flex-direction: column; gap: 2px;"
    }, m("label", {
      htmlFor: "chkKnockout",
      style: "font-weight: bold; color: var(--heading-color); font-size: 0.95em; cursor: pointer; margin: 0;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_knockout', {}, 'Es eliminatoria directa (Knockout)')), m("span", {
      style: "font-size: 0.8em; color: var(--muted-color);"
    }, "Habilita en La Bolilla el pron\xF3stico obligatorio de qu\xE9 equipo se clasifica o gana la eliminatoria (+1 punto adicional)."))), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, "Estado del Partido"), m("select", {
      className: "FormControl",
      value: this.status,
      onchange: e => {
        this.status = e.target.value;
        m.redraw();
      },
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); height: 40px;"
    }, m("option", {
      value: "scheduled"
    }, "Programado (Pendiente de disputar)"), m("option", {
      value: "finished"
    }, "Normal (Finalizado con resultado)"), m("option", {
      value: "suspended_with_lineup"
    }, "\u26A0\uFE0F Suspendido (11 Aldeanos otorgado)"), m("option", {
      value: "suspended_without_lineup"
    }, "\u26A0\uFE0F Suspendido (sin 11 Aldeanos)"))), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_opponent'), " *"), m("select", {
      className: "FormControl",
      value: this.rivalId,
      onchange: e => {
        const rId = e.target.value;
        this.rivalId = rId;
        const found = this.rivals.find(r => String(r.id()) === String(rId));
        if (found) {
          this.opponent = found.name();
        } else {
          this.opponent = '';
        }
        m.redraw();
      },
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); height: 40px;"
    }, m("option", {
      value: ""
    }, "-- Selecciona un Rival --"), this.rivals.map(r => m("option", {
      value: r.id()
    }, r.name())))), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_date')), "                                 ", m("input", {
      className: "FormControl",
      type: "datetime-local",
      value: this.matchDate,
      onchange: e => {
        this.matchDate = e.target.value;
        m.redraw();
      },
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_team'), " *"), m("select", {
      className: "FormControl",
      value: this.teamId,
      onchange: e => {
        this.teamId = e.target.value;
        m.redraw();
      },
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); height: 40px;"
    }, m("option", {
      value: ""
    }, "-- " + app.translator.trans('bizkaitarra-lineup.forum.matches.field_team') + " --"), this.teams.map(t => m("option", {
      value: t.id()
    }, t.name())))), m("h3", {
      style: "font-size: 1.1em; font-weight: bold; margin: 15px 0 5px 0; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 8px; color: var(--heading-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.section_extra_links')), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_press_conference_url')), m("input", {
      className: "FormControl",
      placeholder: "https://...",
      value: this.pressConferenceUrl,
      oninput: e => this.pressConferenceUrl = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_callup_url')), m("input", {
      className: "FormControl",
      placeholder: "https://...",
      value: this.callupUrl,
      oninput: e => this.callupUrl = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_tv_channel')), m("input", {
      className: "FormControl",
      placeholder: "Ej: DAZN, LaLiga TV, Movistar+",
      value: this.tvChannel,
      oninput: e => this.tvChannel = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.field_preview_url')), m("input", {
      className: "FormControl",
      placeholder: "https://...",
      value: this.previewUrl,
      oninput: e => this.previewUrl = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("h3", {
      style: "font-size: 1.1em; font-weight: bold; margin: 15px 0 5px 0; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 8px; color: var(--heading-color);"
    }, "Informaci\xF3n Post-Partido y Arbitraje"), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, "Enlace a Rueda de prensa posterior"), m("input", {
      className: "FormControl",
      placeholder: "https://...",
      value: this.postPressConferenceUrl,
      oninput: e => this.postPressConferenceUrl = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, "Enlace a Resumen del partido"), m("input", {
      className: "FormControl",
      placeholder: "https://...",
      value: this.highlightsUrl,
      oninput: e => this.highlightsUrl = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, "Enlace a Partido completo"), m("input", {
      className: "FormControl",
      placeholder: "https://...",
      value: this.fullMatchUrl,
      oninput: e => this.fullMatchUrl = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 15px;"
    }, m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, "\xC1rbitro Principal"), m("input", {
      className: "FormControl",
      placeholder: "Ej: Munuera Montero",
      value: this.referee,
      oninput: e => this.referee = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, "\xC1rbitro VAR"), m("input", {
      className: "FormControl",
      placeholder: "Ej: Hern\xE1ndez Hern\xE1ndez",
      value: this.varReferee,
      oninput: e => this.varReferee = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    }))), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, "Asistencia (espectadores)"), m("input", {
      className: "FormControl",
      type: "number",
      min: "0",
      placeholder: "Ej: 48500",
      value: this.attendance,
      oninput: e => this.attendance = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;"
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, "Cr\xF3nica / Notas del Partido (Editor Enriquecido / BBCode / Markdown)"), m("textarea", {
      className: "FormControl",
      rows: "6",
      placeholder: "Escribe la cr\xF3nica o notas del encuentro usando BBCode o Markdown...",
      value: this.notesHtml,
      oninput: e => this.notesHtml = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 12px 14px; font-family: inherit; resize: vertical;"
    })), m("div", {
      style: "display: flex; justify-content: flex-end; gap: 15px; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 20px; margin-top: 10px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.matches'),
      className: "Button",
      style: "border-radius: 8px; padding: 10px 20px; font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.btn_cancel')), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.saving,
      style: "border-radius: 8px; padding: 10px 24px; font-weight: bold; display: inline-flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-save"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.matches.btn_save_data')))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/EditMatchBasicPage', EditMatchBasicPage);